import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { GetVendorProfiles } from "../../common/CommonApi";

const VendorDetails = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [vendor,setVendor] = useState({})
  const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
      getProfile();
    }, []);
  
    const getProfile = async () => {
      const data = await GetVendorProfiles(id);
      console.log("data",data.data.data)
      setVendor(data.data.data);
    //   setModules(data.data.data.permissions || []);
    };

    const openPreview = (url) => {
    setPreviewImage(url);
  };

  const closePreview = () => {
    setPreviewImage(null);
  };

  const displayFields = [
    { label: "Full Name", value: vendor.fullname },
    { label: "Email", value: vendor.email },
    { label: "Phone", value: vendor.phone },
    { label: "Company Name", value: vendor.companyName },
    { label: "Address", value: vendor.address },
    { label: "Category", value: vendor.category },
    { label: "Message", value: vendor.message },
    { label: "Role", value: vendor.role },
    // { label: "Permissions", value: vendor?.permissions.join(", ") },
    { label: "Account Status", value: vendor.accountStatus },
    { label: "Is Active", value: vendor.isActive ? "Yes" : "No" },
    { label: "Is Vendor", value: vendor.isVendor ? "Yes" : "No" },
    { label: "GST", value: vendor.gst },
    { label: "IFSC", value: vendor.ifsc },
    { label: "Legal Name", value: vendor.legalName },
    { label: "PAN", value: vendor.pan },
    { label: "Account Holder", value: vendor.accountHolder },
    { label: "Account Number", value: vendor.accountNumber },
    { label: "Bank Name", value: vendor.bankName },
    {
      label: "Created Date",
      value: new Date(vendor.createdDate).toLocaleString(),
    },
    {
      label: "Last Modified",
      value: new Date(vendor.lastModifiedDate).toLocaleString(),
    },
  ];


  const renderDocument = (url, alt) => {
  if (!url) return <span>No Image Found</span>;

  const isPdf = url.toLowerCase().includes(".pdf");

  if (isPdf) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#007bff",
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        View PDF
      </a>
    );
  }

  return (
    <Image
      src={url}
      alt={alt || "Document"}
      onClick={() => openPreview(url)}
      style={{ cursor: "pointer" }}
    />
  );
};

  return (
    <Container>
      <Title>Vendor Details</Title>

      <FormGrid>
        {displayFields.map((field, index) => (
          <FormField key={index}>
            <Label>{field.label}</Label>
            <Input value={field.value || "—"} readOnly />
          </FormField>
        ))}
      </FormGrid>

      <Divider />
      <ImageSection>
        <SectionTitle>Uploaded Documents</SectionTitle>

        <ImageGrid>
          <ImageCard>
            <Label>Cancelled Cheque</Label>
            {renderDocument(vendor.cancelledCheque, "Cancelled Cheque")}
          </ImageCard>

          <ImageCard>
            <Label>Digital Signature</Label>
            {renderDocument(vendor.digitalSignature, "Digital Signature")}
          </ImageCard>

          <ImageCard>
            <Label>Govt ID</Label>
            {renderDocument(vendor.govtId, "Govt ID")}
          </ImageCard>

          <ImageCard>
            <Label>Trade License</Label>
            {renderDocument(vendor.tradeLicense, "Trade License")}
          </ImageCard>
        </ImageGrid>
      </ImageSection>
      {previewImage && (
        <ModalOverlay2 onClick={closePreview}>
          <ModalContent2 onClick={(e) => e.stopPropagation()}>
            <CloseButton2 onClick={closePreview}>×</CloseButton2>
            <PreviewImage2 src={previewImage} alt="Preview" />
          </ModalContent2>
        </ModalOverlay2>
      )}
    </Container>
  );
};

export default VendorDetails;

// ================= Styled Components =================

const Container = styled.div`
  max-width: 1100px;
  margin: 40px auto;
  background-color: #f9fafb;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h2`
  color: #111827;
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px 40px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  color: #4b5563;
  font-weight: 500;
  font-size: 0.95rem;
  margin-bottom: 6px;
`;

const Input = styled.input`
  background-color: #f9f9f9;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.95rem;
  color: #111827;
  outline: none;
  cursor: not-allowed;
`;

const Divider = styled.hr`
  margin: 40px 0;
  border: none;
  border-top: 1px solid #e5e7eb;
`;

const ImageSection = styled.div`
  margin-top: 20px;
`;

const SectionTitle = styled.h3`
  color: #111827;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 20px;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 24px;
`;

const ImageCard = styled.div`
  display: flex;
  flex-direction: column;
`;

const Image = styled.img`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  object-fit: cover;
  height: 180px;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`;


const ModalOverlay2 = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent2 = styled.div`
  position: relative;
  background: white;
  padding: 16px;
  border-radius: 12px;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PreviewImage2 = styled.img`
  max-width: 100%;
  max-height: 80vh;
  border-radius: 8px;
  object-fit: contain;
`;

const CloseButton2 = styled.button`
  position: absolute;
  top: 10px;
  right: 14px;
  background: #111827;
  color: white;
  border: none;
  font-size: 1.6rem;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  cursor: pointer;
  line-height: 1;
  transition: 0.2s;
  &:hover {
    background: #374151;
  }
`;